/* LARK theme scripts — no dependencies, no build step. */
(function () {
  'use strict';

  /* --- Mobile navigation ------------------------------------------------- */
  var burger = document.querySelector('[data-burger]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (burger && mobileNav) {
    burger.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* --- Quantity steppers -------------------------------------------------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    if (!input) return;
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.getAttribute('data-step') === 'up' ? 1 : -1;
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var next = (parseInt(input.value, 10) || min) + step;
        input.value = next < min ? min : next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* --- Product gallery ---------------------------------------------------- */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var alt = thumb.getAttribute('data-alt') || '';
        if (main && src) {
          main.setAttribute('src', src);
          main.setAttribute('alt', alt);
        }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });
  }

  /* --- Variant picker ----------------------------------------------------- */
  document.querySelectorAll('[data-variants]').forEach(function (form) {
    var data = form.querySelector('[data-variant-json]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = form.querySelector('[data-variant-price]');
    var submit = form.querySelector('[data-variant-submit]');

    form.querySelectorAll('input[name="lark-variant"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var id = parseInt(radio.value, 10);
        var v = variants.filter(function (x) { return x.id === id; })[0];
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl && v.price_formatted) priceEl.textContent = v.price_formatted;
        if (submit) {
          submit.disabled = !v.available;
          submit.textContent = v.available ? submit.getAttribute('data-label') : 'Sold out';
        }
      });
    });
  });

  /* --- Experiences calendar ----------------------------------------------- */
  var calRoot = document.querySelector('[data-calendar]');
  if (calRoot) initCalendar(calRoot);

  function initCalendar(root) {
    var raw = root.querySelector('[data-sessions-json]');
    if (!raw) return;

    var sessions;
    try { sessions = JSON.parse(raw.textContent); } catch (e) { return; }

    sessions = sessions.filter(function (s) { return s.date && /^\d{4}-\d{2}-\d{2}$/.test(s.date); });
    sessions.sort(function (a, b) { return a.date < b.date ? -1 : a.date > b.date ? 1 : 0; });

    var byDate = {};
    sessions.forEach(function (s) {
      if (!byDate[s.date]) byDate[s.date] = [];
      byDate[s.date].push(s);
    });

    var monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'];
    var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    var grid = root.querySelector('[data-cal-grid]');
    var monthLabel = root.querySelector('[data-cal-month]');
    var yearLabel = root.querySelector('[data-cal-year]');
    var panel = root.querySelector('[data-cal-panel]');
    var panelDate = root.querySelector('[data-cal-panel-date]');
    var prevBtn = root.querySelector('[data-cal-prev]');
    var nextBtn = root.querySelector('[data-cal-next]');
    var emptyTpl = root.querySelector('[data-cal-empty]');

    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var firstKey = sessions.length ? sessions[0].date : null;
    var view = firstKey ? new Date(firstKey + 'T00:00:00') : new Date(today);
    view = new Date(view.getFullYear(), view.getMonth(), 1);

    var selected = firstKey;

    function key(y, m, d) {
      return y + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
    }

    function hasOpenSeats(list) {
      return list.some(function (s) { return s.available; });
    }

    function renderGrid() {
      if (!grid) return;
      grid.innerHTML = '';

      ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].forEach(function (d) {
        var el = document.createElement('div');
        el.className = 'cal__dow';
        el.textContent = d;
        grid.appendChild(el);
      });

      var year = view.getFullYear();
      var month = view.getMonth();
      var offset = new Date(year, month, 1).getDay();
      var days = new Date(year, month + 1, 0).getDate();
      var cellCount = Math.ceil((offset + days) / 7) * 7;

      for (var i = 0; i < cellCount; i++) {
        var dayNum = i - offset + 1;
        if (dayNum < 1 || dayNum > days) {
          var blank = document.createElement('div');
          blank.className = 'cal__day';
          blank.setAttribute('aria-hidden', 'true');
          grid.appendChild(blank);
          continue;
        }

        var k = key(year, month, dayNum);
        var list = byDate[k];
        var cell = document.createElement(list ? 'button' : 'div');
        cell.className = 'cal__day' + (list ? ' cal__day--has' : '') + (k === selected ? ' cal__day--sel' : '');

        var label = document.createElement('span');
        label.textContent = String(dayNum);
        cell.appendChild(label);

        if (list) {
          cell.type = 'button';
          cell.setAttribute('data-date', k);
          var open = hasOpenSeats(list);
          cell.setAttribute('aria-label',
            dayNames[new Date(year, month, dayNum).getDay()] + ' ' + monthNames[month] + ' ' + dayNum +
            ', ' + list.length + (list.length === 1 ? ' session' : ' sessions') +
            (open ? '' : ', sold out'));
          if (k === selected) cell.setAttribute('aria-current', 'date');
          var dot = document.createElement('span');
          dot.className = 'cal__dot' + (open ? '' : ' cal__dot--out');
          cell.appendChild(dot);
          cell.addEventListener('click', function () {
            selected = this.getAttribute('data-date');
            renderGrid();
            renderPanel();
          });
        }

        grid.appendChild(cell);
      }

      if (monthLabel) monthLabel.textContent = monthNames[month];
      if (yearLabel) yearLabel.textContent = String(year);

      if (prevBtn) prevBtn.disabled = !hasSessionsBefore(year, month);
      if (nextBtn) nextBtn.disabled = !hasSessionsAfter(year, month);
    }

    function hasSessionsBefore(y, m) {
      return sessions.some(function (s) {
        var d = new Date(s.date + 'T00:00:00');
        return d.getFullYear() < y || (d.getFullYear() === y && d.getMonth() < m);
      });
    }

    function hasSessionsAfter(y, m) {
      return sessions.some(function (s) {
        var d = new Date(s.date + 'T00:00:00');
        return d.getFullYear() > y || (d.getFullYear() === y && d.getMonth() > m);
      });
    }

    function renderPanel() {
      if (!panel) return;
      var list = byDate[selected] || [];

      if (panelDate && selected) {
        var d = new Date(selected + 'T00:00:00');
        panelDate.textContent = dayNames[d.getDay()] + ', ' + monthNames[d.getMonth()] + ' ' + d.getDate();
      }

      panel.innerHTML = '';

      if (!list.length) {
        if (emptyTpl) panel.appendChild(emptyTpl.content.cloneNode(true));
        return;
      }

      list.forEach(function (s) {
        var card = document.createElement('div');
        card.className = 'session';

        var head = document.createElement('div');
        head.style.cssText = 'display:flex;align-items:baseline;justify-content:space-between;gap:16px;';

        var titles = document.createElement('div');
        titles.className = 'stack';
        titles.style.gap = '7px';
        if (s.kind) {
          var kind = document.createElement('div');
          kind.className = 'card__kind';
          kind.textContent = s.kind;
          titles.appendChild(kind);
        }
        var title = document.createElement('a');
        title.className = 'card__title';
        title.style.fontSize = '25px';
        title.href = s.url || '#';
        title.textContent = s.title || '';
        titles.appendChild(title);
        head.appendChild(titles);

        if (s.time) {
          var time = document.createElement('div');
          time.style.cssText = 'font-size:15px;white-space:nowrap;';
          time.textContent = s.time;
          head.appendChild(time);
        }
        card.appendChild(head);

        if (s.summary) {
          var note = document.createElement('p');
          note.className = 'muted';
          note.style.cssText = 'font-size:14px;line-height:1.8;';
          note.textContent = s.summary;
          card.appendChild(note);
        }

        var rule = document.createElement('hr');
        rule.className = 'rule';
        card.appendChild(rule);

        var foot = document.createElement('div');
        foot.style.cssText = 'display:flex;align-items:center;justify-content:space-between;gap:16px;flex-wrap:wrap;';

        var left = document.createElement('div');
        left.className = 'stack';
        left.style.gap = '4px';
        var seats = document.createElement('div');
        seats.className = 'session__seats' + (s.available ? '' : ' session__seats--out');
        if (!s.available) {
          seats.textContent = 'Sold out';
        } else if (typeof s.seats_left === 'number' && s.seats_left > 0) {
          seats.textContent = s.seats_left + ' of ' + (s.seats_total || s.seats_left) + ' seats left';
        } else {
          seats.textContent = 'Seats available';
        }
        left.appendChild(seats);
        if (s.price) {
          var price = document.createElement('div');
          price.style.cssText = 'font-size:13px;';
          price.className = 'muted';
          price.textContent = s.price + ' per seat';
          left.appendChild(price);
        }
        foot.appendChild(left);

        var cta = document.createElement('a');
        cta.className = 'btn' + (s.available ? '' : ' btn--outline');
        cta.style.minHeight = '50px';
        cta.href = s.url || '#';
        cta.textContent = s.available ? 'Reserve a seat' : 'Join the waiting list';
        foot.appendChild(cta);

        card.appendChild(foot);
        panel.appendChild(card);
      });
    }

    function shiftMonth(delta) {
      view = new Date(view.getFullYear(), view.getMonth() + delta, 1);
      renderGrid();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { shiftMonth(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { shiftMonth(1); });

    renderGrid();
    renderPanel();
  }
})();
